export const listRegistrations = `
   query listRegistrations($filter: RegistrationsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listRegistrations(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              productCode
              customerIdentifier
              customerAWSAccountId
              marketplaceToken
              created
              updated
           }
           nextToken
       }
   }
`;

export const getRegistration = `
   query getRegistration($id:ID!) {
       getRegistration(id:$id) {
         id
         productCode
         customerIdentifier    
         customerAWSAccountId     
         marketplaceToken
         created
         updated
       } 
}`;
